import { useState } from 'react';
import { DashboardCard } from '@/components/ui/dashboard-card.tsx';

export const ManualTrade = () => {
  const [tradeType, setTradeType] = useState<'buy' | 'sell'>('buy');
  const [amount, setAmount] = useState('');
  const [price, setPrice] = useState('');
  const onExecute = () => {};
  return (
    <DashboardCard>
      <div className="mb-4 text-base font-semibold">Manual Trade</div>
      <div className="flex flex-col gap-3.5">
        <div>
          <label className="mb-1.5 block text-base font-medium text-zinc-500">Type</label>
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => setTradeType('buy')}
              className={[
                'flex-1 rounded-md border border-zinc-200 px-3 py-2 text-base font-semibold',
                tradeType === 'buy' ? 'bg-blue-500 text-white' : 'bg-white text-zinc-900',
              ].join(' ')}
            >
              BUY
            </button>
            <button
              type="button"
              onClick={() => setTradeType('sell')}
              className={[
                'flex-1 rounded-md border border-zinc-200 px-3 py-2 text-base font-semibold',
                tradeType === 'sell' ? 'bg-green-500 text-white' : 'bg-white text-zinc-900',
              ].join(' ')}
            >
              SELL
            </button>
          </div>
        </div>
        <div>
          <label className="mb-1.5 block text-base font-medium text-zinc-500">
            Amount (kWh)
          </label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter amount"
            className="w-full rounded-md border border-zinc-200 bg-white px-3 py-2 text-base text-zinc-900"
          />
        </div>
        <div>
          <label className="mb-1.5 block text-base font-medium text-zinc-500">
            Price (€/MWh)
          </label>
          <input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            placeholder="Enter price"
            className="w-full rounded-md border border-zinc-200 bg-white px-3 py-2 text-base text-zinc-900"
          />
        </div>
        <button
          type="button"
          onClick={onExecute}
          className="mt-1 w-full rounded-md bg-zinc-900 px-4 py-2 text-base font-semibold text-white"
        >
          Execute Trade
        </button>
      </div>
    </DashboardCard>
  );
};

export default ManualTrade;
